
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import axios from 'axios'
export default {
components: {
XHeader,
Group,
XInput,
XButton,
Selector,
Toast
},
data () {
return {
uid: '',
uname: '',
wxId: '',
email: '',
phoneNum: '',
codes: '',
uname1: '',
rela1: '',
phoneNum1: '',
uname2: '',
rela2: '',
phoneNum2: '',
showPositionValue: false,
result: false,
show1: false,
position: 'center',
toastText: '',
disabled: false,
btntxt: '获取验证码',
time:0,
save: false,
relaList: [
{
key: '001',
value: '父子'
},
{
key: '002',
value: '父女'
},
{
key: '003',
value: '母子'
},
{
key: '004',
value: '母女'
},
{
key: '005',
value: '其他'
}
]
}
},
mounted() {
},
methods: {

sendCode(){

var reg=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
var phoneNum = this.phoneNum;
if(phoneNum==''){

this.showPositionValue = true;
this.toastText = "手机号码不能为空！";
return ;
}else if(!reg.test(phoneNum)){

this.showPositionValue = true;
this.toastText = "请输入合法的手机号码！";
return ;
}else{
this.time=60;
this.disabled=true;
this.timer();
}




},
timer(){
if (this.time > 0) {
this.time--;
this.btntxt = this.time+"s后重新获取";
setTimeout(this.timer, 1000);
} else{
this.time = 0;
this.btntxt = "获取验证码";
this.disabled = false;
}
},

checkCode(){
var params = {
username:this.phoneNum,
code:this.codes
}




this.result = true;
},

verify(){
var reg1= /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/;
var reg2=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
if(this.uname==''){
this.showPositionValue = true;
this.toastText = "姓名不能为空！";
return;
}

if(this.wxId==''){
this.showPositionValue = true;
this.toastText = "微信号不能为空！";
return;
}else{
if(!reg1.test(this.wxId)){
this.showPositionValue = true;
this.toastText = "请输入正确的微信号码！";
return;
}
}

if(this.email==''){
this.showPositionValue = true;
this.toastText = "邮箱不能为空！";
return;
}else{
if(!reg2.test(this.email)){
this.showPositionValue = true;
this.toastText = "请输入有效的邮箱！";
return;
}
}
this.saveItems();
},
saveItems(){
if(this.result){
alert("===="+this.result)
this.showPositionValue = true;
this.toastText = '==========';
var infoList = {
'uname': this.uname,
'wxId': this.wxId,
'email': this.email,
'phoneNum': this.phoneNum









};
if(this.uname1!=''){
infoList['uname1'] = this.uname1;
}
if(this.rela1!=''){
infoList['rela1'] = this.rela1;
}
if(this.phoneNum1!=''){
infoList['phoneNum1'] = this.phoneNum1;
}
if(this.uname2!=''){
infoList['uname2'] = this.uname2;
}
if(this.rela2!=''){
infoList['rela2'] = this.rela2;
}
if(this.phoneNum2!=''){
infoList['phoneNum2'] = this.phoneNum2;
}
console.log(infoList)
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/perdetiles.vue